const config = {
    tablePageSize: 25,
    tableRowHeight: 40,
    ncdmTableRowHeight: 28,
    defaultMapZoom: 8,
    statewideACSEndpoint: `${process.env.REACT_APP_MAP_SERVICE}/DemographicProfile/MapServer/2/query?outFields=*&returnGeometry=false&f=json&where=MDCode%3D`,
    countyACSEndpoint: `${process.env.REACT_APP_MAP_SERVICE}/DemographicProfile/MapServer/1/query?outFields=*&returnGeometry=false&f=json&where=MDCode%3D`,
    tractACSEndpoint2019: `${process.env.REACT_APP_MAP_SERVICE}/DemographicProfile/MapServer/2019/query?outFields=*&returnGeometry=false&f=json&where=GEOID%3D`,
    tractACSEndpoint2021: `${process.env.REACT_APP_MAP_SERVICE}/DemographicProfile/MapServer/2021/query?outFields=*&returnGeometry=false&f=json&where=GEOID%3D`,
    homeContentEndpoint: `${process.env.REACT_APP_EPHT_API}/config/GetHomeContent`,
    ncdmConfigEndpoint: `${process.env.REACT_APP_EPHT_API}/NCDM/GetNCDMConfig`,
    getNcdmDataEndpoint: `${process.env.REACT_APP_EPHT_API}/NCDM/GetNCDMData`,
    getDataYearsEndpoint: `${process.env.REACT_APP_EPHT_API}/config/GetDataYears`,
    stateBounds: [
        [39.74, -75.17],
        [37.91, -79.48],
    ],
    timeSliderMapCenter: {
        lat: 38.830880426900734,
        lng: -77.325,
    },
    missing: -999,
    suppressed: -777,
    nationWideCode: '888',
    lessThanPointOne: -555,
    missingText: 'Missing*',
    suppressedText: 'Suppressed*',
    lessThanPointOneText: '<0.1',
    mdhAttribution:
        'SOURCE: Maryland Department of Health Environmental Public Health Tracking',
};

export default config;
